define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"dojo/dom-construct",
	"csi/html",
	"csi/heading/_base",
	"csi/heading/NodeImage",
	"csi/heading/RefContainer",
	"dojo/text!./templates/CatalogProduct.html",
	"dojo/text!./html/CatalogColor.html",
	"./_CatalogProduct",
	"./ProductProperties",
	"./CatalogPromo"
], function(array, declare, domConstruct, html, headingBase, NodeImage, RefContainer, template, templateColor, _CatalogProduct, ProductProperties) {

	var _ColorImageRen = declare(NodeImage, {
		bClientPath: true,
		pathImage: "Child:MasterColor/Child:ColorSwatchImageNode"
	}),

		_LookImageRen = declare(NodeImage, {
			bClientPath: true,
			pathImage: "Child:MasterLook"
		}),

		_LooksRen = declare(RefContainer, {
			getReferencedNodes: function(/*Context*/ctx, /*Heading*/h) {
				return ctx.view.getAvailableLooks();
			}
		});

	return declare(_CatalogProduct, {
		bForceImages: true,
		prefClass: null,
		templateString: template,

		// {String:Heading}: map of headings to use when colors do not exist
		_noColorHeadings: null,

		getAvailableLooks: function() {
			// summary: return list of available looks
			var looks = this.cacheView.getNodes(this.getViewNode().Looks);
			return array.filter(looks, function(l) {return l.Available;});
		},

		getCatalogColors: function(/*Node[]*/colors) {
			// summary: return list of available colors
			return array.filter(colors, function(c) {return c.Available;});
		},

		getColorImageNode: function(/*Node*/color) {
			// summary: return node for color that contains images
			return this.cacheView.getNode(color.MasterColor);
		},

		onCatalogHeadings: function(/*Heading[]*/h) {
			// summary: populate _productHeadings and _colorHeadings
			var ch = h[2].m_subheadings;
			var smpg = this._productGroup;

			this._productHeadings = {
				name: h[0],
				code: h[1],
				colors: h[2],
				sizes: h[3],
				docs: h[4],
				brands: h[5],
				features: h[6],
				looks: (!smpg || (smpg.$Type == "SalesCollection")) ? h[7] : null
			};

			this._noColorHeadings = {
				image: h[8],
				desc: h[9],
				wholesale: (!smpg || smpg.ShowWholesalePrice) ? h[10] : null,
				retail: (!smpg || smpg.ShowRetailPrice) ? h[11] : null,
				promos: (!smpg || smpg.ShowPromos) ? h[12] : null
			};

			this._colorHeadings = {
				image: ch[1],
				name: ch[2],
				code: ch[3],
				desc: ch[4],
				wholesale: (!smpg || smpg.ShowWholesalePrice) ? ch[5] : null,
				retail: (!smpg || smpg.ShowRetailPrice) ? ch[6] : null,
				promos: (!smpg || smpg.ShowPromos) ? ch[7] : null
			};

			// assign special renderer for looks to only show available looks
			h[7].classRenderer = _LooksRen;
			h[7].m_subheadings[0].classRenderer = _LookImageRen;

			// assign special renderer for color matrix - we need each image in matrix to be
			// in context of SMProductColor which is reason to use renderer with pathImage;
			// once color selected, the image needs to be in context of ColorSwatchImageNode (ch[1])
			ch[0].classRenderer = _ColorImageRen;
		},

		onRenderCatalogColor: function() {
			// summary: render color-specific information
			var ctx = this.getContext(this._urlColorHighlight || this._urlColor || this.getViewURL());
			var ch = this._colorHeadings;
			var nch = this._noColorHeadings;

			// populate color header
			html.destroyChildren(this.colorNode);
			domConstruct.place(html.templateToHtml(ctx, templateColor, this._urlColor ? ch : nch), this.colorNode);

			// populate color description
			headingBase.clearHtml(this.colorDescNode);
			headingBase.toHtml(ctx, this._urlColor ? ch.desc : nch.desc, this.colorDescNode);
		},

		onRenderCatalogProduct: function(/*Context*/ctx, /*Deferred[]*/dfds) {
			// summary: build attribute groups for Brands, Features, Looks, Summary, Details, and Documents
			const {
				brandsNode,
				detailsNode,
				dimsNode,
				docsNode,
				featuresNode,
				looksNode,
				summaryNode,
				_productHeadings,
				_urlColor,
			} = this;

			const {
				brands,
				colors,
				docs,
				features,
				looks,
				sizes,
			} = _productHeadings;

			const dimHeadings = [];

			if (_urlColor) {
				dimHeadings.push(colors);
			}

			if (ctx.getNode().SalesProductSizes.length) {
				dimHeadings.push(sizes);
			}

			dfds.push(ProductProperties.summary(ctx, summaryNode));
			dfds.push(ProductProperties.details(ctx, detailsNode));
			dfds.push(ProductProperties.generate(ctx, dimsNode, dimHeadings));
			dfds.push(ProductProperties.generate(ctx, brandsNode, [brands], brands.m_name));
			dfds.push(ProductProperties.generate(ctx, featuresNode, [features], features.m_name));
			dfds.push(ProductProperties.generate(ctx, docsNode, [docs], docs.m_name));

			if (looks && this.getAvailableLooks().length) {
				dfds.push(ProductProperties.generate(ctx, looksNode, [looks], looks.m_name));
			}
		},

		// Property view overrides

		refreshImages: function(/*String?*/key) {
			// summary: display warning if no images for color (hide if there are images)
			html.setVisible(this.warningNode, !this._getColorImageNode());
			this.inherited(arguments);
		},

		_onRootDependencyPaths: function(/*String[]*/paths) {
			// summary: add paths from summary and details views and color images due to custom getImageContainer code
			paths.push("Child:Colors/Child:MasterColor/Child:Images");
			ProductProperties.addPaths(paths);
			this.inherited(arguments);
		},

		_onPreViewSearch: function() {
			// summary: load appropriate custom views for both summary and details views
			const smProduct = this.getViewNode();
			const mcProduct = this.cacheView.get(smProduct.MasterProduct);
			const dfd = ProductProperties.reset(mcProduct);

			return this.when(dfd, (result) => {
				this._buildView();
			});
		}
	});
});